/* =============================================
   FWG Commercial Vehicle Wraps — Inquiry Form
   Assets: fwg-inquiry-form.js
   ============================================= */

var FWG_CONFIG = {
  SUPABASE_URL: 'https://yjpllbljqrczkfhodozi.supabase.co',
  SUPABASE_ANON_KEY: 'sb_publishable_9aGFQdl82HAw23uFfSIjCA_d4Qmi6Bp',
  API_URL: 'https://ops.frederickwraps.com',
  THANK_YOU_URL: '/pages/thank-you',
  STORAGE_BUCKET: 'form-uploads'
};

/* ── Constants ── */
var TOTAL_STEPS = 6;
var currentStep = 1;
var completedSteps = new Set();

/* ── Stepper Navigation ── */
function goToStep(target) {
  if (target < 1 || target > TOTAL_STEPS || target === currentStep) return;
  var isForward = target > currentStep;
  if (isForward) {
    for (var s = currentStep; s < target; s++) {
      var errors = getStepErrors(s);
      if (errors.length > 0) {
        highlightErrors(s, errors);
        if (errors.includes('aiAcknowledge')) {
          showToast('AI artwork requires acknowledgment');
          openAiPolicyModal();
        } else {
          showToast('Please fill in all required fields');
        }
        return;
      }
      completedSteps.add(s);
    }
  }
  if (!isForward && getStepErrors(currentStep).length === 0) {
    completedSteps.add(currentStep);
  }
  switchCard(target);
}

function switchCard(target) {
  var currentCard = document.querySelector('.step-card[data-step="' + currentStep + '"]');
  if (currentCard) currentCard.classList.remove('active');
  if (target === 6) buildSummary();
  var targetCard = document.querySelector('.step-card[data-step="' + target + '"]');
  if (targetCard) {
    void targetCard.offsetWidth;
    targetCard.classList.add('active');
  }
  currentStep = target;
  updateStepper();
  var stepper = document.getElementById('stepper');
  if (stepper) {
    stepper.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/* ── Validation ── */
function getStepErrors(stepNum) {
  var errors = [];
  switch (stepNum) {
    case 1:
      if (!document.getElementById('businessName').value.trim()) errors.push('businessName');
      if (!document.getElementById('contactName').value.trim()) errors.push('contactName');
      if (!document.getElementById('email').value.trim()) errors.push('email');
      if (!document.getElementById('phone').value.trim()) errors.push('phone');
      if (!document.getElementById('contactMethodHidden').value) errors.push('contactMethod');
      break;
    case 2:
      var blocks = document.querySelectorAll('#vehicleBlocksContainer .vehicle-block');
      var anyType = false;
      blocks.forEach(function(b) { if (b.querySelector('.vtype-hidden') && b.querySelector('.vtype-hidden').value) anyType = true; });
      if (!anyType) errors.push('vehicleType');
      break;
    case 3:
      if (!document.getElementById('projectTypeHidden').value) errors.push('coverageType');
      break;
    case 4:
      if (!document.getElementById('artworkStatusHidden').value) errors.push('artworkStatus');
      else if (document.getElementById('artworkStatusHidden').value === 'ai_mockup' && document.getElementById('aiAcknowledged').value !== 'yes') errors.push('aiAcknowledge');
      break;
    case 5:
      if (!document.getElementById('timeline').value) errors.push('timeline');
      break;
    case 6:
      break;
  }
  return errors;
}

function highlightErrors(stepNum, errors) {
  document.querySelectorAll('.field-error').forEach(function(el) { el.classList.remove('field-error'); });
  var card = document.querySelector('.step-card[data-step="' + stepNum + '"]');
  if (!card) return;
  card.classList.remove('shake');
  void card.offsetWidth;
  card.classList.add('shake');
  errors.forEach(function(errKey) {
    switch(errKey) {
      case 'businessName': case 'contactName': case 'email': case 'phone':
        var el = document.getElementById(errKey);
        if (el) el.closest('.field-group').classList.add('field-error');
        break;
      case 'contactMethod':
        var cm = document.querySelector('.contact-method-group');
        if (cm) cm.closest('.field-group').classList.add('field-error');
        break;
      case 'vehicleType':
        var vg = document.querySelector('.vtype-grid');
        if (vg) vg.closest('.field-group').classList.add('field-error');
        break;
      case 'coverageType':
        var cg = document.querySelector('.coverage-type-group');
        if (cg) cg.closest('.field-group').classList.add('field-error');
        break;
      case 'artworkStatus':
      case 'aiAcknowledge':
        var ar = document.querySelector('.artwork-rows');
        if (ar) ar.closest('.field-group').classList.add('field-error');
        break;
      case 'timeline':
        var tl = document.getElementById('timeline');
        if (tl) tl.closest('.field-group').classList.add('field-error');
        break;
    }
  });
}

document.addEventListener('input', function() {
  document.querySelectorAll('.field-error').forEach(function(el) { el.classList.remove('field-error'); });
});
document.addEventListener('click', function(e) {
  if (e.target.closest('.contact-method-btn, .coverage-type-btn, .artwork-row, .vtype-card')) {
    document.querySelectorAll('.field-error').forEach(function(el) { el.classList.remove('field-error'); });
  }
});

function updateStepper() {
  document.querySelectorAll('.step-indicator').forEach(function(ind) {
    var step = parseInt(ind.dataset.step);
    ind.classList.remove('active', 'completed');
    if (step === currentStep) {
      ind.classList.add('active');
    } else if (completedSteps.has(step)) {
      ind.classList.add('completed');
    }
  });
}

/* ── Label Maps ── */
var coverageLabels = { full_wrap:'Full Coverage Wrap', partial_wrap:'Partial Wrap', graphics_lettering:'Graphics & Lettering', not_sure:'Not Sure Yet' };
var artworkLabels = { fleet_match:'Fleet Match', print_ready:'Print-Ready Artwork', logo_vision:'Logo + Vision', logo_only:'Logo Only', from_scratch:'Start from Scratch', ai_mockup:'AI-Generated Mockup' };
var timelineLabels = { asap:'ASAP / As soon as possible', '30_days':'Within 30 days', '30_60_days':'30\u201360 days', '60_90_days':'60\u201390+ days', planning:'Just planning / gathering info' };
var budgetLabels = { under_1000:'Under $1,000', '1000_2500':'$1,000 \u2013 $2,500', '2500_5000':'$2,500 \u2013 $5,000', '5000_10000':'$5,000 \u2013 $10,000', '10000_plus':'$10,000+', not_sure:'Not sure yet' };

/* ── Summary Builder ── */
function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

function summaryRow(label, value) {
  return '<div class="summary__row"><span class="summary__label">' + label + '</span><span class="summary__value">' + (value || '<span style="color:#B0B0B0;">\u2014</span>') + '</span></div>';
}

function editBtn(step) {
  return '<button type="button" class="btn-edit" onclick="goToStep(' + step + ')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg> Edit</button>';
}

function sectionHeader(num, title, step) {
  return '<div class="summary__section-header"><div class="summary__section-title"><span class="summary__section-num">' + num + '</span> ' + title + '</div>' + editBtn(step) + '</div>';
}

function buildSummary() {
  var html = '';
  html += '<div class="summary__section">';
  html += sectionHeader('01', 'Business Contact', 1);
  html += summaryRow('Business', esc(document.getElementById('businessName').value));
  html += summaryRow('Contact', esc(document.getElementById('contactName').value));
  html += summaryRow('Email', esc(document.getElementById('email').value));
  html += summaryRow('Phone', esc(document.getElementById('phone').value));
  var cm = document.getElementById('contactMethodHidden').value;
  var cmLabel = cm === 'email' ? 'Email' : cm === 'text' ? 'Text' : cm === 'call' ? 'Call' : '';
  html += summaryRow('Preferred', cmLabel);
  html += '</div>';

  html += '<div class="summary__section">';
  html += sectionHeader('02', 'Vehicle Details', 2);
  var blocks = document.querySelectorAll('#vehicleBlocksContainer .vehicle-block');
  blocks.forEach(function(block, idx) {
    var bid = block.dataset.id;
    var data = getVehicleData(bid);
    if (!data) return;
    var vtObj = vehicleTypes.find(function(v) { return v.value === data.vtype; });
    var typeLabel = vtObj ? vtObj.label : '\u2014';
    html += '<div class="summary__vehicle-card">';
    html += '<div class="summary__vehicle-label">Vehicle ' + (idx + 1) + '</div>';
    html += summaryRow('Type', esc(typeLabel));
    if (data.isOther) {
      html += summaryRow('Description', esc(data.otherDesc || '\u2014'));
    } else {
      html += summaryRow('Year', esc(data.year || '\u2014'));
      html += summaryRow('Make', esc(data.make || '\u2014'));
      html += summaryRow('Model', esc(data.model || '\u2014'));
      var colorVal = '\u2014';
      if (data.color) {
        if (data.color === 'other' && data.colorOther) colorVal = data.colorOther;
        else { var cm2 = vehicleColors.find(function(c) { return c.value === data.color; }); if (cm2) colorVal = cm2.label; }
      }
      html += summaryRow('Color', esc(colorVal));
      if (vtObj && data.conditionals) {
        vtObj.fields.forEach(function(fk) {
          var fd = conditionalOptions[fk];
          if (fd && data.conditionals[fk]) html += summaryRow(fd.label, esc(data.conditionals[fk]));
        });
      }
      if (data.browsing) html += summaryRow('Note', "Exploring options \u2014 don't have vehicle yet");
    }
    html += '</div>';
  });
  html += '</div>';

  html += '<div class="summary__section">';
  html += sectionHeader('03', 'Coverage Type', 3);
  var ct = document.getElementById('projectTypeHidden').value;
  html += summaryRow('Type', coverageLabels[ct] || '\u2014');
  html += '</div>';

  html += '<div class="summary__section">';
  html += sectionHeader('04', 'Artwork & Design', 4);
  var aw = document.getElementById('artworkStatusHidden').value;
  html += summaryRow('Status', artworkLabels[aw] || '\u2014');
  if (aw === 'ai_mockup') html += summaryRow('AI Policy', '<span style="color:var(--fwg-green);font-weight:600;">\u2713 Acknowledged</span>');
  var logoInput = document.querySelector('input[name="logo_file"]');
  if (logoInput && logoInput.files && logoInput.files.length > 0) {
    html += summaryRow('Logo File', esc(Array.from(logoInput.files).map(function(f) { return f.name; }).join(', ')));
  }
  html += '</div>';

  html += '<div class="summary__section">';
  html += sectionHeader('05', 'Timeline & Budget', 5);
  var tl = document.getElementById('timeline').value;
  html += summaryRow('Timeline', timelineLabels[tl] || '\u2014');
  var bg = document.getElementById('budget').value;
  if (bg) html += summaryRow('Budget', budgetLabels[bg] || '\u2014');
  html += '</div>';

  document.getElementById('summaryContainer').innerHTML = html;
}

/* Card height equalization removed — cards now size to their content */

/* ── Vehicle Data ── */
var vehicleCounter = 0;
var container, countDisplay;

var yearOptions = [];
for (var y = 2026; y >= 2016; y--) yearOptions.push(String(y));

var vehicleColors = [
  {value:'white',label:'White',hex:'#FFFFFF'},{value:'black',label:'Black',hex:'#1A1A1A'},
  {value:'gray',label:'Gray',hex:'#808080'},{value:'silver',label:'Silver',hex:'#C0C0C0'},
  {value:'blue',label:'Blue',hex:'#2B5EA7'},{value:'red',label:'Red',hex:'#C0392B'},
  {value:'brown',label:'Brown',hex:'#6B4226'},{value:'green',label:'Green',hex:'#2E7D32'},
  {value:'beige',label:'Beige / Tan',hex:'#C8B88A'},{value:'yellow',label:'Yellow',hex:'#F1C40F'},
  {value:'orange',label:'Orange',hex:'#E67E22'},{value:'other',label:'Other',hex:null}
];

var typeExamples = {
  coupe_sedan: { make:'Honda', model:'Civic' },
  minivan_suv: { make:'Ford', model:'Escape' },
  pickup: { make:'Toyota', model:'Tacoma' },
  compact_cargo_van:{ make:'Ford', model:'Transit Connect' },
  box_truck: { make:'Isuzu', model:'NPR' },
  enclosed_trailer:{ make:'', model:'6x12 Enclosed' },
  heavy_duty: { make:'Freightliner', model:'MV607' },
  bus: { make:'IC Bus', model:'CE' }
};

var vehicleTypes = [
  { value:'coupe_sedan', label:'Coupe / Sedan', examples:'Civic, Camry, Model 3', fields:[], photosRequired:false, isOther:false },
  { value:'minivan_suv', label:'Minivans / SUV', examples:'Escape, CR-V, Sienna, Suburban', fields:[], photosRequired:false, isOther:false },
  { value:'pickup', label:'Pickup Truck', examples:'Tacoma, Silverado 2500, F-250', fields:['cab_size','bed_size'], photosRequired:false, isOther:false },
  { value:'compact_cargo_van', label:'Compact / Cargo Van', examples:'Transit Connect, ProMaster, Sprinter', fields:['roof_height','van_wheelbase'], photosRequired:false, isOther:false },
  { value:'box_truck', label:'Box Truck', examples:'NPR, E-Series Cutaway, Express Cutaway', fields:['box_length','box_height'], photosRequired:true, isOther:false },
  { value:'enclosed_trailer', label:'Enclosed Trailer', examples:'6x12 Enclosed, ST Cargo, 70SA', fields:['trailer_length','trailer_height','panel_fasteners'], photosRequired:true, isOther:false },
  { value:'heavy_duty', label:'Commercial / Heavy Duty Trucks', examples:'MV607, F-650, W900', fields:[], photosRequired:false, isOther:false },
  { value:'bus', label:'Buses', examples:'IC CE, MCI J4500, E-450 Cutaway', fields:[], photosRequired:false, isOther:false },
  { value:'other', label:'Other', examples:'Custom or specialty equipment', fields:[], photosRequired:true, isOther:true }
];

var conditionalOptions = {
  cab_size: { label:'Cab Size', options:['Standard Cab','Extended Cab','Full Cab'] },
  bed_size: { label:'Bed Size', options:['Short Bed','Standard Bed','Long Bed'] },
  van_wheelbase: { label:'Wheelbase', options:['Compact','Short','Standard','Extended'] },
  roof_height: { label:'Roof Height', options:['Compact','Low','Medium','High'] },
  box_length: { label:'Box Length', options:['10ft','12ft','14ft','16ft','20ft','24ft','26ft'] },
  box_height: { label:'Box Height', options:['7ft','8ft (most common)','8.5ft','9ft'] },
  trailer_length: { label:'Trailer Length', options:['6ft','7ft','8ft','9ft','10ft','11ft','12ft','13ft','14ft','15ft','16ft','17ft','18ft','19ft','20ft','21ft','22ft','23ft','24ft'] },
  trailer_height: { label:'Trailer Height', options:['7ft','8ft (most common)','8.5ft','9ft'] },
  panel_fasteners: { label:'Panel Fasteners', options:['Rivets','Screws'] }
};

var icons = {
  copy:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3H4a1 1 0 00-1 1v14"/><rect x="8" y="7" width="13" height="14" rx="1"/></svg>',
  duplicate:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><line x1="17.5" y1="14" x2="17.5" y2="21"/><line x1="14" y1="17.5" x2="21" y2="17.5"/></svg>',
  remove:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
  upload:'<svg class="file-upload__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
  chevron:'<svg class="color-picker__chevron" viewBox="0 0 12 8" fill="none" stroke="#7D7D7D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l5 5 5-5"/></svg>'
};

/* ── Contact Method ── */
function selectContactMethod(btn) {
  document.querySelectorAll('.contact-method-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('contactMethodHidden').value = btn.dataset.value;
}

/* ── Artwork Selection ── */
function selectArtwork(row) {
  var value = row.dataset.value;
  if (value === 'ai_mockup') {
    document.querySelectorAll('.artwork-row').forEach(function(r) { r.classList.remove('selected'); });
    row.classList.add('selected');
    openAiPolicyModal();
    return;
  }
  document.querySelectorAll('.artwork-row').forEach(function(r) { r.classList.remove('selected'); });
  row.classList.add('selected');
  document.getElementById('artworkStatusHidden').value = value;
  document.getElementById('aiAcknowledged').value = '';
}

function openAiPolicyModal() {
  document.getElementById('aiPolicyModal').classList.add('visible');
  document.body.style.overflow = 'hidden';
}

function closeAiPolicyModal() {
  document.getElementById('aiPolicyModal').classList.remove('visible');
  document.body.style.overflow = '';
}

function acknowledgeAiPolicy() {
  document.getElementById('artworkStatusHidden').value = 'ai_mockup';
  document.getElementById('aiAcknowledged').value = 'yes';
  closeAiPolicyModal();
  showToast('AI artwork policy acknowledged');
}

function cancelAiSelection(e) {
  if (e.target === e.currentTarget) cancelAiFromModal();
}

function cancelAiFromModal() {
  closeAiPolicyModal();
  document.querySelectorAll('.artwork-row').forEach(function(r) { r.classList.remove('selected'); });
  document.getElementById('artworkStatusHidden').value = '';
  document.getElementById('aiAcknowledged').value = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && document.getElementById('aiPolicyModal').classList.contains('visible')) {
    cancelAiFromModal();
  }
});

/* ── Coverage Specs ── */
var coverageSpecs = {
  full_wrap: {
    title: 'Full Coverage Wrap',
    specs: [
      { label: 'Price Range', filled: 6, total: 7 },
      { label: 'Brand Impact', filled: 7, total: 7 },
      { label: 'Coverage', filled: 7, total: 7 },
      { label: 'Durability', filled: 7, total: 7 },
      { label: 'Paint Protection', filled: 4, total: 7 },
      { label: 'Install Time', filled: 6, total: 7 }
    ]
  },
  partial_wrap: {
    title: 'Partial Wrap',
    specs: [
      { label: 'Price Range', filled: 4, total: 7 },
      { label: 'Brand Impact', filled: 5, total: 7 },
      { label: 'Coverage', filled: 4, total: 7 },
      { label: 'Durability', filled: 7, total: 7 },
      { label: 'Paint Protection', filled: 3, total: 7 },
      { label: 'Install Time', filled: 3, total: 7 }
    ]
  },
  graphics_lettering: {
    title: 'Graphics & Lettering',
    specs: [
      { label: 'Price Range', filled: 2, total: 7 },
      { label: 'Brand Impact', filled: 3, total: 7 },
      { label: 'Coverage', filled: 2, total: 7 },
      { label: 'Durability', filled: 7, total: 7 },
      { label: 'Paint Protection', filled: 1, total: 7 },
      { label: 'Install Time', filled: 3, total: 7 }
    ]
  }
};

function selectCoverageType(btn) {
  document.querySelectorAll('.coverage-type-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('projectTypeHidden').value = btn.dataset.value;
  var toggleBtn = document.getElementById('specsToggleBtn');
  var panel = document.getElementById('specsPanel');
  if (coverageSpecs[btn.dataset.value]) {
    toggleBtn.style.display = '';
    renderSpecsPanel(btn.dataset.value);
  } else {
    toggleBtn.style.display = 'none';
    panel.classList.remove('visible');
    panel.innerHTML = '';
    toggleBtn.classList.remove('open');
    document.getElementById('specsToggleLabel').textContent = 'Show Specs';
  }
}

function toggleSpecsPanel() {
  var panel = document.getElementById('specsPanel');
  var btn = document.getElementById('specsToggleBtn');
  var label = document.getElementById('specsToggleLabel');
  var isOpen = panel.classList.toggle('visible');
  btn.classList.toggle('open', isOpen);
  label.textContent = isOpen ? 'Hide Specs' : 'Show Specs';
}

function renderSpecsPanel(typeValue) {
  var panel = document.getElementById('specsPanel');
  var data = coverageSpecs[typeValue];
  if (!data) { panel.innerHTML = ''; return; }
  panel.innerHTML = data.specs.map(function(spec) {
    var dots = '';
    for (var i = 0; i < spec.total; i++) {
      var filled = i < spec.filled;
      var color = filled ? 'var(--fwg-red)' : '#D4D4D4';
      dots += '<span class="specs-panel__dot" style="background:' + color + ';"></span>';
    }
    return '<div class="specs-panel__row"><span class="specs-panel__label">' + spec.label + '</span><div class="specs-panel__dots">' + dots + '</div><span class="specs-panel__value">' + spec.filled + '/' + spec.total + '</span></div>';
  }).join('');
}

/* ── Vehicle Block Builders ── */
function buildYearHTML(sel) {
  var isOlder = sel && !yearOptions.includes(sel);
  var sv = isOlder ? 'older' : sel;
  var h = '<option value="" disabled ' + (!sv ? 'selected' : '') + '>Select year</option>';
  yearOptions.forEach(function(y) { h += '<option value="' + y + '" ' + (sv===y?'selected':'') + '>' + y + '</option>'; });
  h += '<option value="older" ' + (sv==='older'?'selected':'') + '>My vehicle is older than 2016</option>';
  return h;
}

function buildColorOptionsHTML(bid) {
  return vehicleColors.map(function(c) {
    var ss = c.hex ? 'style="background:' + c.hex + ';"' : '';
    var sc = c.value==='other' ? 'color-picker__swatch color-picker__swatch--other' : 'color-picker__swatch';
    return '<div class="color-picker__option" data-value="' + c.value + '" data-label="' + c.label + '" data-hex="' + (c.hex||'') + '" onclick="selectColor(' + bid + ',this)"><span class="' + sc + '" ' + ss + '>' + (c.value==='other'?'?':'') + '</span><span class="color-picker__option-label">' + c.label + '</span></div>';
  }).join('');
}

function buildVehicleTypeSelector(bid, sel) {
  return '<div class="field-group"><label class="field-label">Vehicle Type <span class="required">*</span></label><div class="vtype-grid">' +
  vehicleTypes.map(function(vt) { return '<div class="vtype-card ' + (sel===vt.value?'selected':'') + '" data-vtype="' + vt.value + '" onclick="selectVehicleType(' + bid + ',\'' + vt.value + '\')"><div class="vtype-card__label">' + vt.label + '</div><div class="vtype-card__examples">' + vt.examples + '</div></div>'; }).join('') +
  '</div><input type="hidden" class="vtype-hidden" name="v' + bid + '_type" value="' + (sel||'') + '" /></div>';
}

function buildConditionalFields(bid, vtv, p) {
  var vt = vehicleTypes.find(function(v) { return v.value === vtv; });
  if (!vt) return '';
  var html = '';

  if (vt.isOther) {
    html += '<div class="field-group" style="margin-bottom:16px;"><label class="field-label">What are you looking to have wrapped or lettered? <span class="required">*</span></label><span class="field-helper">Describe the object, equipment, or vehicle \u2014 include dimensions if you know them.</span><textarea class="other-description" name="v' + bid + '_other_desc" placeholder="e.g. Industrial generator housing, 4ft x 6ft x 3ft..." rows="3">' + (p.otherDesc||'') + '</textarea></div>';
    html += '<div class="field-group"><label class="field-label">Upload Photos <span class="required">*</span></label><div class="photo-required-notice">\uD83D\uDCF7 Photos are required so we can evaluate the surface and provide an accurate quote.</div><div class="file-upload file-upload--required" id="upload' + bid + '">' + icons.upload + '<p class="file-upload__text"><strong>Click to upload</strong> or drag and drop</p><input type="file" name="v' + bid + '_photos" multiple accept="image/*" onchange="showFileNames(this,\'upload' + bid + '\')" /><div class="file-names"></div></div></div>';
    return html;
  }

  var isLarge = ['box_truck','enclosed_trailer'].indexOf(vtv) !== -1;
  var ex = typeExamples[vtv] || { make:'Ford', model:'Transit' };
  var browsing = p.browsing || false;

  html += '<div class="field-group"><label class="checkbox-option"><input type="checkbox" class="browsing-check" name="v' + bid + '_browsing" value="yes" ' + (browsing?'checked':'') + ' onchange="toggleBrowsing(' + bid + ')" /><span>I don\'t have this vehicle yet \u2014 just exploring options</span></label><div class="browsing-notice ' + (browsing?'visible':'') + '" id="browsingNotice_' + bid + '">No problem! We can still prepare a general estimate based on the vehicle type and project scope.</div></div>';

  var reqLabel = isLarge ? '<span class="optional">\u2014 not required</span>' : '<span class="required">*</span>';
  html += '<div class="field-row" style="margin-bottom:16px;"><div class="field-group"><label class="field-label">Year ' + reqLabel + '</label><select class="year-select">' + buildYearHTML(p.year) + '</select><input type="hidden" class="year-hidden" name="v' + bid + '_year" value="' + (p.year||'') + '" /><div class="older-vehicle-notice ' + (p.year&&!yearOptions.includes(p.year)?'visible':'') + '"><span>\u26A0\uFE0F</span> For vehicles older than 2016, we\'d like to see the vehicle in person to evaluate paint condition before quoting.<input type="number" class="older-year-input" placeholder="Enter vehicle year" min="1970" max="2015" value="' + (p.year&&!yearOptions.includes(p.year)?p.year:'') + '" /></div></div><div class="field-group"><label class="field-label">Make ' + reqLabel + '</label><input type="text" name="v' + bid + '_make" placeholder="e.g. ' + ex.make + '" value="' + (p.make||'') + '" /></div></div>';
  html += '<div class="field-group" style="margin-bottom:16px;"><label class="field-label">Model ' + reqLabel + '</label><input type="text" name="v' + bid + '_model" placeholder="e.g. ' + ex.model + '" value="' + (p.model||'') + '" /></div>';

  vt.fields.forEach(function(fk) {
    var fd = conditionalOptions[fk];
    var val = p.conditionals ? (p.conditionals[fk]||'') : '';
    html += '<div class="field-group" style="margin-bottom:16px;"><label class="field-label">' + fd.label + ' <span class="required">*</span></label><select name="v' + bid + '_' + fk + '"><option value="" disabled ' + (!val?'selected':'') + '>Select ' + fd.label.toLowerCase() + '</option>' + fd.options.map(function(o) { return '<option value="' + o + '" ' + (val===o?'selected':'') + '>' + o + '</option>'; }).join('') + '</select></div>';
  });

  var tss='',tsi='',tlt='Select vehicle color',tlc='color-picker__trigger-label placeholder',ov=false;
  if(p.color){var m=vehicleColors.find(function(c){return c.value===p.color;});if(m){tlt=m.label;tlc='color-picker__trigger-label';if(p.color==='other'){tss='background:linear-gradient(135deg,#E8E8E8 25%,#D0D0D0 25%,#D0D0D0 50%,#E8E8E8 50%,#E8E8E8 75%,#D0D0D0 75%);background-size:8px 8px;';tsi='<span style="font-size:12px;font-weight:700;color:#7D7D7D;">?</span>';ov=true;}else{tss='background:'+m.hex+';';}}}
  var hcv=p.color==='other'&&p.colorOther?'other:'+p.colorOther:(p.color||'');

  html += '<div class="field-group" style="margin-bottom:16px;"><label class="field-label">Vehicle Color</label><div class="color-picker" data-block="' + bid + '"><input type="hidden" class="color-picker__hidden" name="v' + bid + '_color" value="' + hcv + '" /><button type="button" class="color-picker__trigger" onclick="toggleColorDropdown(' + bid + ')"><span class="color-picker__trigger-swatch" style="' + tss + '">' + tsi + '</span><span class="' + tlc + '">' + tlt + '</span>' + icons.chevron + '</button><div class="color-picker__dropdown">' + buildColorOptionsHTML(bid) + '</div><input type="text" class="color-picker__other-input ' + (ov?'visible':'') + '" placeholder="Describe your vehicle color..." value="' + (p.colorOther||'') + '" /></div></div>';

  if (vt.photosRequired) {
    html += '<div class="field-group"><label class="field-label">Upload Vehicle Photos <span class="required">*</span></label><div class="photo-required-notice">\uD83D\uDCF7 Photos are required for this vehicle type before we can provide a quote \u2014 it makes the process much smoother and faster.</div><div class="file-upload file-upload--required" id="upload' + bid + '">' + icons.upload + '<p class="file-upload__text"><strong>Click to upload</strong> or drag and drop</p><input type="file" name="v' + bid + '_photos" multiple accept="image/*" onchange="showFileNames(this,\'upload' + bid + '\')" /><div class="file-names"></div></div></div>';
  } else {
    html += '<div class="field-group"><label class="field-label">Upload Vehicle Photos</label><span class="field-helper">Optional but highly recommended \u2014 seeing your exact vehicle helps us provide the most accurate quote.</span><div class="file-upload" id="upload' + bid + '">' + icons.upload + '<p class="file-upload__text"><strong>Click to upload</strong> or drag and drop</p><input type="file" name="v' + bid + '_photos" multiple accept="image/*" onchange="showFileNames(this,\'upload' + bid + '\')" /><div class="file-names"></div></div></div>';
  }
  return html;
}

/* ── Vehicle Block CRUD ── */
function createVehicleBlock(prefill) {
  vehicleCounter++;
  var num = vehicleCounter;
  var totalBlocks = container.querySelectorAll('.vehicle-block').length + 1;
  var p = prefill || {vtype:'',year:'',make:'',model:'',color:'',colorOther:'',conditionals:{},browsing:false,otherDesc:''};

  var block = document.createElement('div');
  block.className = 'vehicle-block';
  block.dataset.id = num;

  var actionsHTML = '';
  if (totalBlocks > 1) actionsHTML += '<button type="button" class="btn-vehicle-action btn-copy" onclick="copyFromFirst(' + num + ')">' + icons.copy + ' Copy from Vehicle 1</button>';
  actionsHTML += '<button type="button" class="btn-vehicle-action btn-duplicate" onclick="duplicateVehicle(' + num + ')">' + icons.duplicate + ' Duplicate</button>';
  if (totalBlocks > 1) actionsHTML += '<button type="button" class="btn-vehicle-action btn-remove" onclick="removeVehicle(' + num + ')">' + icons.remove + ' Remove</button>';

  block.innerHTML =
    '<div class="vehicle-block__top-bar"><span class="vehicle-block__title">Vehicle <span class="vb-num">' + totalBlocks + '</span></span><div class="vehicle-block__actions">' + actionsHTML + '</div></div>' +
    buildVehicleTypeSelector(num, p.vtype) +
    '<div class="vtype-prompt" id="vtypePrompt_' + num + '" ' + (p.vtype?'style="display:none;"':'') + '><svg class="vtype-prompt__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg><div class="vtype-prompt__text">Select a vehicle type above to continue</div></div>' +
    '<div class="conditional-fields ' + (p.vtype?'visible':'') + '" id="cond_' + num + '">' + (p.vtype?buildConditionalFields(num,p.vtype,p):'') + '</div>';

  container.appendChild(block);
  if(p.color){var opt=block.querySelector('.color-picker__option[data-value="'+p.color+'"]');if(opt)opt.classList.add('selected');}
  updateVehicleNumbers();
  return num;
}

function selectVehicleType(bid, vtv) {
  var block = container.querySelector('.vehicle-block[data-id="' + bid + '"]');
  if(!block) return;
  block.querySelectorAll('.vtype-card').forEach(function(c){c.classList.remove('selected');});
  block.querySelector('.vtype-card[data-vtype="' + vtv + '"]').classList.add('selected');
  block.querySelector('.vtype-hidden').value = vtv;
  var prompt = block.querySelector('#vtypePrompt_' + bid);
  if(prompt) prompt.style.display = 'none';
  var cc = block.querySelector('.conditional-fields');
  cc.innerHTML = buildConditionalFields(bid, vtv, {year:'',make:'',model:'',color:'',colorOther:'',conditionals:{},browsing:false,otherDesc:''});
  cc.classList.add('visible');
}

function toggleBrowsing(bid) {
  var block = container.querySelector('.vehicle-block[data-id="' + bid + '"]');
  if(!block) return;
  var cb = block.querySelector('.browsing-check');
  var notice = block.querySelector('#browsingNotice_' + bid);
  if(cb.checked) notice.classList.add('visible'); else notice.classList.remove('visible');
}

function getVehicleData(bid) {
  var block = container.querySelector('.vehicle-block[data-id="' + bid + '"]');
  if(!block) return null;
  var vtype = (block.querySelector('.vtype-hidden')||{}).value||'';
  var vt = vehicleTypes.find(function(v){return v.value===vtype;});
  if (vt && vt.isOther) {
    var descEl = block.querySelector('.other-description');
    return { vtype: vtype, otherDesc: descEl?descEl.value:'', isOther:true };
  }
  var yearEl = block.querySelector('.year-hidden');
  var makeEl = block.querySelector('[name$="_make"]');
  var modelEl = block.querySelector('[name$="_model"]');
  var colorEl = block.querySelector('.color-picker__hidden');
  var browseEl = block.querySelector('.browsing-check');
  var cv = colorEl?colorEl.value:'', co='';
  if(cv.indexOf('other:')===0){co=cv.substring(6);cv='other';}
  var conds = {};
  if(vt) vt.fields.forEach(function(fk){var s=block.querySelector('[name$="_'+fk+'"]');if(s)conds[fk]=s.value;});
  return {vtype:vtype, year:yearEl?yearEl.value:'', make:makeEl?makeEl.value:'', model:modelEl?modelEl.value:'', color:cv, colorOther:co, conditionals:conds, browsing:browseEl?browseEl.checked:false};
}

function getFirstVehicleData() { var f=container.querySelector('.vehicle-block'); return f?getVehicleData(f.dataset.id):null; }

function copyFromFirst(tid) {
  var data=getFirstVehicleData(); if(!data) return;
  var block=container.querySelector('.vehicle-block[data-id="'+tid+'"]'); if(!block) return;
  if(data.vtype){
    block.querySelectorAll('.vtype-card').forEach(function(c){c.classList.remove('selected');});
    var card=block.querySelector('.vtype-card[data-vtype="'+data.vtype+'"]');if(card)card.classList.add('selected');
    block.querySelector('.vtype-hidden').value=data.vtype;
    var cc=block.querySelector('.conditional-fields');
    cc.innerHTML=buildConditionalFields(tid,data.vtype,data);cc.classList.add('visible');
    if(data.color){var opt=block.querySelector('.color-picker__option[data-value="'+data.color+'"]');if(opt)opt.classList.add('selected');}
  }
  showToast('Vehicle 1 info copied');
}

function duplicateVehicle(sid) {
  var data=getVehicleData(sid);if(!data)return;
  createVehicleBlock(data);
  var sb=container.querySelector('.vehicle-block[data-id="'+sid+'"]');
  showToast('Vehicle ' + (sb?sb.querySelector('.vb-num').textContent:'') + ' duplicated');
  container.lastElementChild.scrollIntoView({behavior:'smooth',block:'center'});
}

function removeVehicle(bid) {
  var blocks=container.querySelectorAll('.vehicle-block');if(blocks.length<=1)return;
  var block=container.querySelector('.vehicle-block[data-id="'+bid+'"]');if(!block)return;
  block.style.cssText='animation:none;opacity:0;transform:translateY(-8px);transition:all 0.2s ease;';
  setTimeout(function(){block.remove();updateVehicleNumbers();},200);
}

function updateVehicleNumbers() {
  var blocks=container.querySelectorAll('.vehicle-block');
  blocks.forEach(function(block,i){
    var n=i+1; block.querySelector('.vb-num').textContent=n;
    var ad=block.querySelector('.vehicle-block__actions'),bid=block.dataset.id;
    var h='';
    if(n>1)h+='<button type="button" class="btn-vehicle-action btn-copy" onclick="copyFromFirst('+bid+')">'+icons.copy+' Copy from Vehicle 1</button>';
    h+='<button type="button" class="btn-vehicle-action btn-duplicate" onclick="duplicateVehicle('+bid+')">'+icons.duplicate+' Duplicate</button>';
    if(n>1)h+='<button type="button" class="btn-vehicle-action btn-remove" onclick="removeVehicle('+bid+')">'+icons.remove+' Remove</button>';
    ad.innerHTML=h;
  });
  countDisplay.textContent=blocks.length;
}

/* ── Color Picker ── */
function selectColor(bid,el) {
  var pk=el.closest('.color-picker'),tr=pk.querySelector('.color-picker__trigger'),dd=pk.querySelector('.color-picker__dropdown'),hd=pk.querySelector('.color-picker__hidden'),oi=pk.querySelector('.color-picker__other-input'),ts=tr.querySelector('.color-picker__trigger-swatch'),tl=tr.querySelector('.color-picker__trigger-label');
  var v=el.dataset.value,l=el.dataset.label,hex=el.dataset.hex;
  pk.querySelectorAll('.color-picker__option').forEach(function(o){o.classList.remove('selected');});el.classList.add('selected');
  tl.textContent=l;tl.classList.remove('placeholder');
  if(v==='other'){ts.style.background='linear-gradient(135deg,#E8E8E8 25%,#D0D0D0 25%,#D0D0D0 50%,#E8E8E8 50%,#E8E8E8 75%,#D0D0D0 75%)';ts.style.backgroundSize='8px 8px';ts.innerHTML='<span style="font-size:12px;font-weight:700;color:#7D7D7D;">?</span>';oi.classList.add('visible');hd.value='other';setTimeout(function(){oi.focus();},150);}
  else{ts.style.background=hex;ts.style.backgroundSize='';ts.innerHTML='';oi.classList.remove('visible');oi.value='';hd.value=v;}
  dd.classList.remove('open');tr.classList.remove('open');
}

function toggleColorDropdown(bid) {
  var pk=document.querySelector('.color-picker[data-block="'+bid+'"]'),tr=pk.querySelector('.color-picker__trigger'),dd=pk.querySelector('.color-picker__dropdown');
  document.querySelectorAll('.color-picker__dropdown.open').forEach(function(d){if(d!==dd){d.classList.remove('open');d.closest('.color-picker').querySelector('.color-picker__trigger').classList.remove('open');}});
  var o=dd.classList.toggle('open');tr.classList.toggle('open',o);
}

document.addEventListener('click',function(e){if(!e.target.closest('.color-picker')){document.querySelectorAll('.color-picker__dropdown.open').forEach(function(d){d.classList.remove('open');d.closest('.color-picker').querySelector('.color-picker__trigger').classList.remove('open');});}});
document.addEventListener('input',function(e){if(e.target.classList.contains('color-picker__other-input')){e.target.closest('.color-picker').querySelector('.color-picker__hidden').value='other:'+e.target.value;}});
document.addEventListener('change',function(e){if(e.target.classList.contains('year-select')){var vb=e.target.closest('.vehicle-block'),n=vb.querySelector('.older-vehicle-notice'),yi=vb.querySelector('.older-year-input'),yh=vb.querySelector('.year-hidden');if(e.target.value==='older'){n.classList.add('visible');yh.value='';setTimeout(function(){yi.focus();},100);}else{n.classList.remove('visible');yi.value='';yh.value=e.target.value;}}});
document.addEventListener('input',function(e){if(e.target.classList.contains('older-year-input')){e.target.closest('.vehicle-block').querySelector('.year-hidden').value=e.target.value;}});

/* ── Toast ── */
function showToast(m){var t=document.getElementById('toast');t.textContent=m;t.classList.add('show');setTimeout(function(){t.classList.remove('show');},2200);}

/* ── File Names Display ── */
function showFileNames(i,uid){var el=document.querySelector('#'+uid+' .file-names');el.textContent=i.files.length?Array.from(i.files).map(function(f){return f.name;}).join(', '):'';}

/* ── File Upload to Supabase ── */
function uploadFile(file, folder) {
  var timestamp = Date.now();
  var safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  var path = folder + '/' + timestamp + '_' + safeName;
  return fetch(
    FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path,
    {
      method: 'POST',
      headers: {
        'apikey': FWG_CONFIG.SUPABASE_ANON_KEY,
        'Authorization': 'Bearer ' + FWG_CONFIG.SUPABASE_ANON_KEY,
        'Content-Type': file.type,
        'x-upsert': 'true'
      },
      body: file
    }
  ).then(function(response) {
    if (!response.ok) {
      return response.text().then(function(t) { console.error('Upload failed:', file.name, t); return null; });
    }
    return FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/public/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path;
  });
}

function uploadFiles(fileInput, folder) {
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) return Promise.resolve([]);
  var promises = [];
  for (var i = 0; i < fileInput.files.length; i++) {
    promises.push(uploadFile(fileInput.files[i], folder));
  }
  return Promise.all(promises).then(function(urls) {
    return urls.filter(function(u) { return u !== null; });
  });
}

/* ── Collect All Form Data ── */
function collectFormData() {
  var contact = {
    business_name: document.getElementById('businessName').value.trim(),
    contact_name: document.getElementById('contactName').value.trim(),
    email: document.getElementById('email').value.trim(),
    phone: document.getElementById('phone').value.trim(),
    contact_method: document.getElementById('contactMethodHidden').value
  };
  var vehicleBlocks = document.querySelectorAll('#vehicleBlocksContainer .vehicle-block');
  var vehicles = [];
  vehicleBlocks.forEach(function(block) {
    var bid = block.dataset.id;
    var data = getVehicleData(bid);
    if (!data || !data.vtype) return;
    var vtObj = vehicleTypes.find(function(v) { return v.value === data.vtype; });
    if (data.isOther) {
      vehicles.push({
        type: data.vtype,
        type_label: vtObj ? vtObj.label : 'Other',
        other_desc: data.otherDesc || '',
        is_other: true,
        _block_id: bid
      });
    } else {
      vehicles.push({
        type: data.vtype,
        type_label: vtObj ? vtObj.label : '',
        year: data.year || '',
        make: data.make || '',
        model: data.model || '',
        color: data.color || '',
        color_other: data.colorOther || '',
        browsing: data.browsing || false,
        conditionals: data.conditionals || {},
        is_other: false,
        _block_id: bid
      });
    }
  });
  var coverage_type = document.getElementById('projectTypeHidden').value;
  var artwork_status = document.getElementById('artworkStatusHidden').value;
  var ai_acknowledged = document.getElementById('aiAcknowledged').value === 'yes';
  var timeline = document.getElementById('timeline').value;
  var budgetEl = document.getElementById('budget');
  var budget = budgetEl ? budgetEl.value : '';
  var additionalEl = document.getElementById('additionalInfo');
  var additional_info = additionalEl ? additionalEl.value.trim() : '';
  return {
    business_name: contact.business_name,
    contact_name: contact.contact_name,
    email: contact.email,
    phone: contact.phone,
    contact_method: contact.contact_method,
    vehicles: vehicles,
    coverage_type: coverage_type,
    artwork_status: artwork_status,
    ai_acknowledged: ai_acknowledged,
    timeline: timeline,
    budget: budget || null,
    additional_info: additional_info || null,
    source_page: window.location.pathname,
    user_agent: navigator.userAgent
  };
}

/* ── Submit Handler ── */
function initFormSubmit() {
  document.getElementById('fwgInquiryForm').addEventListener('submit', function(e) {
    e.preventDefault();
    for (var i = 1; i <= TOTAL_STEPS; i++) {
      var errors = getStepErrors(i);
      if (errors.length > 0) {
        switchCard(i);
        (function(step, errs) {
          setTimeout(function() { highlightErrors(step, errs); }, 50);
        })(i, errors);
        if (errors.includes('aiAcknowledge')) {
          showToast('AI artwork requires acknowledgment');
          openAiPolicyModal();
        } else {
          showToast('Please fill in all required fields');
        }
        return;
      }
    }
    var formData = collectFormData();
    var submitBtn = document.querySelector('.btn-submit, [type="submit"]');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;"><svg width="18" height="18" viewBox="0 0 24 24" style="animation:spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="31 31" stroke-linecap="round"/></svg> Submitting...</span>';
    }
    var submissionId = Date.now() + '_' + Math.random().toString(36).substring(2, 8);
    var folder = 'submissions/' + submissionId;
    var uploadChain = Promise.resolve();
    formData.vehicles.forEach(function(v) {
      uploadChain = uploadChain.then(function() {
        var photoInput = document.querySelector('[name="v' + v._block_id + '_photos"]');
        return uploadFiles(photoInput, folder + '/vehicle_' + v._block_id).then(function(photoUrls) {
          v.photo_urls = photoUrls;
          delete v._block_id;
        });
      });
    });
    uploadChain
    .then(function() {
      var logoInput = document.querySelector('input[name="logo_file"]');
      return uploadFiles(logoInput, folder + '/logos');
    })
    .then(function(logoUrls) {
      var payload = {
        business_name: formData.business_name,
        contact_name: formData.contact_name,
        email: formData.email,
        phone: formData.phone,
        contact_method: formData.contact_method,
        vehicles: formData.vehicles,
        coverage_type: formData.coverage_type,
        artwork_status: formData.artwork_status,
        ai_acknowledged: formData.ai_acknowledged,
        logo_urls: logoUrls,
        timeline: formData.timeline,
        budget: formData.budget,
        additional_info: formData.additional_info,
        source_page: formData.source_page,
        user_agent: formData.user_agent
      };

      FWG_ATTR_FORM.attach(payload);
      return fetch(FWG_CONFIG.API_URL + '/api/submissions/public', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .then(function(response) {
      if (!response.ok) {
        return response.text().then(function(t) { throw new Error('Submission failed: ' + t); });
      }
      showToast('Quote request submitted!');
      setTimeout(function() {
        window.location.href = FWG_CONFIG.THANK_YOU_URL;
      }, 800);
    })
    .catch(function(err) {
      console.error('Form submission error:', err);
      showToast('Something went wrong. Please try again or call us directly.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  });
}

/* ── Initialize ── */
document.addEventListener('DOMContentLoaded', function() {
  container = document.getElementById('vehicleBlocksContainer');
  countDisplay = document.getElementById('vehicleCountDisplay');
  document.getElementById('btnAddVehicle').addEventListener('click', function() {
    createVehicleBlock();
    container.lastElementChild.scrollIntoView({behavior:'smooth',block:'center'});
  });
  createVehicleBlock();
  initFormSubmit();
});
